import React from 'react';
import PropTypes from 'prop-types';
import ModalV4 from '../../../../app/ui/modal/v4/v4';

import Loading from '../../../gd-ui/loading/loading';
import ActionRequiredForm from '../../../views/action-required/custom-view/form'
import PrioritiesForm from '../../../views/priorities/custom-view/form'
import ProjectsListForm from '../../../views/projects-list/custom-view/form'
import PortfolioForm from '../../../../app/quick-add/sections/view/components/forms/projects/portfolio';
import TasksByUserForm from '../../../views/tasks-by-user/custom-view/form'
import BoardForm from 'core/views/board/custom-view/form'
import EventsSummaryForm from '../../../views/events-summary/custom-view/form'
import WhatsDoneForm from '../../../views/whats-done/custom-view/form'
import ResourcePlanningForm from '../../../../app/quick-add/sections/view/components/forms/resource-planning';
import PastdueForm from '../../../views/pastdue/custom-view/form'
import CalendarForm from '../../../views/calendar/custom-view/form'
import ActivityStreamForm from '../../../views/activity/custom-view/form'
import TaskListForm from '../../../views/list/custom-view/form';
import TableForm from 'core/views/table/custom-view/form'
import WorkloadForm from '../../../views/workload/custom-view/form'
import GanttForm from '../../../views/gantt/custom-view/form'
import ModalV4Header from "../../../../app/ui/modal/v4/header/v4-header";
import MyWorkViewProto from "../../../../app/quick-add/sections/view/components/forms/my-work/my-work-proto";
import {when} from 'simply-deferred';
import {ViewType} from "../../../gd/const/views/view-type";

const debug = {
    dev: false,
    head: 'EditView Form'
}

module.exports = class ModalEditViewSettings extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            viewId: PropTypes.string.isRequired,
            viewType: PropTypes.number.isRequired,
            onSubmit: PropTypes.func,
        }),
    };

    constructor(props) {
        super(props);

        this.view = gd.session.customViews.get(this.props.params.viewId);

        this.state = {
            loading: true
        };
    }

    componentDidMount() {

        when(this.view.loadSettings()).then(()=>{
            this.setState({ loading: false });
        })
        //
        // gd.api.Views.getSettings(this.props.params.viewId).done(model => {
        //     this.setState({ loading: false, viewModel: model });
        // })
    }

    renderLoading() {

        debug.dev && console.log(debug.head, ".renderLoading()");

        return <Loading />;
    }

    renderForm() {

        debug.dev && console.log(debug.head, ".renderForm()");

        let Form = () => null;
        switch (this.props.params.viewType) {
            case ViewType.CUSTOM_VIEW_ACTION_REQUIRED:    Form = ActionRequiredForm; break;
            case ViewType.CUSTOM_VIEW_PRIORITIES:         Form = PrioritiesForm; break;
            case ViewType.PROJECTS_PROJECTS_LIST:         Form = ProjectsListForm; break;
            case ViewType.PROJECTS_PORTFOLIO:             Form = PortfolioForm; break;
            case ViewType.CUSTOM_VIEW_TASKS_BY_USER:      Form = TasksByUserForm; break;
            case ViewType.PROJECT_BOARD:                  Form = BoardForm; break;
            case ViewType.CUSTOM_VIEW_EVENTS_SUMMARY:     Form = EventsSummaryForm; break;
            case ViewType.CUSTOM_VIEW_WHATS_DONE:         Form = WhatsDoneForm; break;
            case ViewType.RESOURCE_PLANNING:              Form = ResourcePlanningForm; break;
            case ViewType.CUSTOM_VIEW_PASTDUE:            Form = PastdueForm; break;
            case ViewType.PROJECT_CALENDAR:               Form = CalendarForm; break;
            case ViewType.PROJECT_ACTIVITY:               Form = ActivityStreamForm; break;
            // case ViewType.RECENT:                         Form = PersonalViewForm; break;
            case ViewType.PROJECT_LIST:                   Form = TaskListForm; break;
            case ViewType.PROJECT_WORKLOAD:               Form = WorkloadForm; break;
            case ViewType.PROJECT_GANTT:                  Form = GanttForm; break;
            case ViewType.PROJECT_TABLE:                  Form = TableForm; break;

            case ViewType.MY_TIME:
            case ViewType.MY_TASKS_LIST:
                Form = MyWorkViewProto;
                break;
        }

        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ModalV4Header height={60} title="Edit view" onClose={this.closeModal} />
                <Form mode="update"
                      organizationId={gd.companyId}
                      view={this.view}
                      onSubmit={this.props.params.onSubmit} />
            </div>
        )
    }

    render() {
        debug.dev && console.log(debug.head, ".render()");
        return this.state.loading ? this.renderLoading() : this.renderForm();
    }
};